import { Injectable } from "@angular/core";
import { AccountJwt } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  IAMAccountPasswordUpdateRequestDTO,
  IAMAccountSignInRequestDTO,
  IAMAccountSignInResponseDTO
} from "../dtos";

@Injectable()
export class IAMAccountService {
  constructor(private readonly apiService: ApiService) {}

  iamAccountPasswordUpdate(
    iamAccountPasswordUpdateRequestDTO: IAMAccountPasswordUpdateRequestDTO
  ): Observable<void> {
    const { currentPassword, newPassword } =
      iamAccountPasswordUpdateRequestDTO.data;

    return this.apiService.put<void>("iam/password", {
      currentPassword,
      newPassword
    });
  }

  iamAccountSignIn(
    iamAccountSignInRequest: IAMAccountSignInRequestDTO
  ): Observable<IAMAccountSignInResponseDTO> {
    const { identity, password } = iamAccountSignInRequest.data;

    return this.apiService
      .post<{ token: AccountJwt }>("iam/sign-in", {
        identity,
        password
      })
      .pipe(
        map((_) => new IAMAccountSignInResponseDTO({ accountJwt: _.token }))
      );
  }
}
